import { PermissionResponse, RealmA6bEnum, Role } from '@goldcast/api/backend';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State } from './types';

export const getInitialState = () => ({
  permissionConfig: {} as PermissionResponse,
  rolesByRealm: {} as Record<RealmA6bEnum, Array<Role>>,
  isLoadingRoles: false
});

const state: State = getInitialState();

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
